/**
 * Estado da lista na URL (situação, filtro rápido, ordem, direção e busca),
 * para o link poder ser compartilhado. A busca escreve na URL com 150 ms de
 * atraso; o campo responde na hora (UI otimista).
 */
import { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { ORDENS } from "../dados/filtros";
import { SITUACOES } from "../dados/montarClientes";

const ATRASO_DA_BUSCA_MS = 150;
const PADRAO = { situacao: SITUACOES.EM_ANDAMENTO, ordem: ORDENS.RISCO, dir: "asc" };

export default function useEstadoDaLista() {
  const [params, setParams] = useSearchParams();
  const situacao = params.get("situacao") || PADRAO.situacao;
  const rapido = params.get("filtro") || "";
  const ordem = params.get("ordem") || PADRAO.ordem;
  const direcao = params.get("dir") === "desc" ? -1 : 1;
  const buscaNaUrl = params.get("q") || "";
  const [busca, setBuscaLocal] = useState(buscaNaUrl);
  const temporizador = useRef(null);

  const mudar = useCallback((mudancas) => {
    setParams((atual) => {
      const proximo = new URLSearchParams(atual);
      Object.entries(mudancas).forEach(([chave, valor]) => {
        if (!valor || valor === PADRAO[chave]) proximo.delete(chave);
        else proximo.set(chave, valor);
      });
      return proximo;
    }, { replace: true });
  }, [setParams]);

  useEffect(() => () => clearTimeout(temporizador.current), []);

  const setBusca = useCallback((texto) => {
    setBuscaLocal(texto);
    clearTimeout(temporizador.current);
    temporizador.current = setTimeout(() => mudar({ q: texto.trim() }), ATRASO_DA_BUSCA_MS);
  }, [mudar]);

  return {
    situacao,
    rapido,
    ordem,
    direcao,
    busca,
    buscaAplicada: buscaNaUrl,
    setBusca,
    setSituacao: (valor) => mudar({ situacao: valor }),
    alternarRapido: (valor) => mudar({ filtro: rapido === valor ? "" : valor }),
    ordenarPor: (valor) => mudar({
      ordem: valor,
      dir: ordem === valor && direcao === 1 ? "desc" : "asc",
    }),
    limpar: () => {
      setBuscaLocal("");
      mudar({ q: "", filtro: "" });
    },
  };
}
